import { CommitmentsRollbackService_commitmentRollbackServicePostFrame } from '@festina/life-general-types/life/hooks/CommitmentsRollbackService_commitmentRollbackServicePostFrame'

export const useFetchRollbackFrame =
  CommitmentsRollbackService_commitmentRollbackServicePostFrame.useSuspenseQuery
